import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AdjustIcon from '@mui/icons-material/Adjust';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import EditIcon from '@mui/icons-material/Edit';
import styles from './Stepper.module.css';
import { ApplicationBuyerQuestionnaireStepsLabels } from '../../../Lib/Constants/vendor-application-form-step';

function Stepper({
  steps,
  activeStep,
  displayedStep,
  onClick = () => {},
  editMode = false,
  clickable = true,
  isSecondExecutiveApproved = false,
}) {
  const handleKeyDown = (event, index) => {
    if (event.key === 'Enter' && !editMode) {
      onClick(index);
    }
  };

  const renderIcon = (index) => {
    if (index < activeStep || isSecondExecutiveApproved) {
      return <CheckCircleIcon />;
    }
    if (editMode && index === displayedStep) {
      return <EditIcon />;
    }

    if (index === activeStep) {
      return <AdjustIcon />;
    }
    return <RadioButtonUncheckedIcon />;
  };

  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => (
        <div
          className={cx(styles.step, {
            [styles.pointer]: clickable,
            [styles.completed]:
              (index < activeStep && (!editMode || index !== displayedStep)) ||
              isSecondExecutiveApproved,
            [styles.current]: index === activeStep,
            [styles.displayed]: index === displayedStep,
          })}
          key={step}
          onClick={() => !editMode && onClick(index)}
          onKeyDown={(event) => handleKeyDown(event, index)}
          role="button"
          tabIndex={0}
        >
          {renderIcon(index)}
          {ApplicationBuyerQuestionnaireStepsLabels[step] || step}
        </div>
      ))}
    </div>
  );
}

Stepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStep: PropTypes.number.isRequired,
  displayedStep: PropTypes.number.isRequired,
  editMode: PropTypes.bool,
  isSecondExecutiveApproved: PropTypes.bool,
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
};

export default Stepper;
